exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-form-group{overflow:hidden}.cube-form-group-legend{font-size:14px;color:#999;background-color:#f3f4f5}", ""]);

// exports
